
/**
 * titleObj: {
 *   label: string*,
 *   xPos: number //default 7,
 *   align: string //default "center"
 * }
 * infoObj: {
 *   xPos: number //default 6.2,
 *   objs: [
 *     {
 *       header: string*,
 *       value: string*,
 *       headerWidth: number, //default 0.5,
 *     }
 *   }
 * ]
 */
export const printTopRight = ({ jsPDFDoc, titleObj, infoObj, startY, contentSize}) => {
 
  let yPos = startY
  jsPDFDoc.setFont("THSarabun", "bold")
  jsPDFDoc.setFontSize(titleObj.size || 22)
  jsPDFDoc.text(titleObj?.label || "-", titleObj.xPos || 7, yPos, { align: titleObj.align || "center" })

  jsPDFDoc.setFont("THSarabun", "bold")
  jsPDFDoc.setFontSize(contentSize || 14)
  const lineHeightTopRight = 0.25
  const yPosTopRight = yPos + lineHeightTopRight
  const xPosTopRight = infoObj.xPos || 6.2
  let xPos = xPosTopRight
  yPos = yPosTopRight
  for(const obj of infoObj.objs) {
    xPos = xPosTopRight
    jsPDFDoc.setFont("THSarabun", "bold")
    jsPDFDoc.text(obj.header, xPos, yPos)
    jsPDFDoc.setFont("THSarabun", "normal")
    xPos += obj.headerWidth || 0.5
    jsPDFDoc.text(obj.value, xPos, yPos)
    yPos += lineHeightTopRight
  }
  // jsPDFDoc.text("วันที่ : ", xPos, yPos)
  // yPos += lineHeightTopRight
  // jsPDFDoc.text("บัญชี : ", xPos, yPos)
  // yPos += lineHeightTopRight
  // jsPDFDoc.setFont("THSarabun", "normal")
  // yPos = yPosTopRight
  // xPos += 0.65
  // jsPDFDoc.text(dayjs(pcPeriodData.PCPrdTm).format("DD/MM/YYYY HH:mm"), xPos, yPos)
  // yPos += lineHeightTopRight
  // const foundPCJnl = msData.pcJournalCombo.find(item=>item.id === pcPeriodData.PCJnlId)
  // jsPDFDoc.text(foundPCJnl?.label || "-", xPos, yPos)
  // yPos += lineHeightTopRight
  return yPos
}